import React from 'react'
import DestinationTourPackage from './DestinationTourPackage'
import Testmonial from '../packagepage/Testmonial'
import UseSMT from '../packagepage/UseSMT'
import TestmonialVideo from '../packagepage/TestmonialVideo'

const DestinationDetails = () => {
    return (
        <>
            <DestinationTourPackage />
            <Testmonial />
            <TestmonialVideo />
            <UseSMT />
        </>
    )
}

export default DestinationDetails
